import PropTypes from 'prop-types'
import { Box, Heading } from '@redriverpress/system'

import { VideoDataShape } from '../constants/VideoPropType'

import UpNextSkeleton from './skeletons/UpNextSkeleton'
import UpcomingVideo from './UpcomingVideo'

export default function WatchNextSection({ playlist, showSkeleton, ...props }) {
  return (
    <Box display='flex' flexDirection='column' {...props}>
      <Heading as='h3' mb={3} fontSize={[2, null, 4, 3]} fontWeight='600'>
        More like this
      </Heading>
      {showSkeleton ? (
        <UpNextSkeleton />
      ) : (
        playlist.map(data => (
          <UpcomingVideo
            key={data.id}
            videoSlug={data.slug}
            thumbnailUrl={data.image}
            title={data.title}
            subheading={data.subtitle}
          />
        ))
      )}
    </Box>
  )
}

WatchNextSection.displayName = 'WatchNextSection'

WatchNextSection.defaultProps = {
  playlist: [],
}

WatchNextSection.propTypes = {
  showSkeleton: PropTypes.bool.isRequired,
  playlist: VideoDataShape.playlist,
}
